import { AxiosResponse } from 'axios';
import { axiosInstance } from '..';

export function getListFacturation(
  filters: {
    statusIds?: number[],
    emissionDateFrom?: string,
    emissionDateTo?: string
  },
  search?:string,
  page: number = 1,
  pageSize: number = 10,
  supplierIds?: number[]
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  params.append('page', page.toString());
  params.append('pageSize', pageSize.toString());

  if (search && search.trim() !== '') {
    params.append('search', search.trim());
  }

  if (filters.statusIds) {
    filters.statusIds.forEach(id => params.append('statusIds', id.toString()));
  }

  if (supplierIds && supplierIds.length > 0) {
    supplierIds.forEach(id => params.append('supplierIds', id.toString()));
  }
  
  if (filters.emissionDateFrom) {
    params.append('emissionDateFrom', filters.emissionDateFrom);
  }
  if (filters.emissionDateTo) {
    params.append('emissionDateTo', filters.emissionDateTo);
  }


  return axiosInstance.get(`Facturation/ListFacturation`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getListStatusFacturation(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Facturation/ListStatusFacturation`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function observeFacturation(
  facturationId: number, 
  observation: string
): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(
    `Facturation/ObserveFacturation/${facturationId}`,
    { observation },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }
  );
}

export function downloadFacturationExcel(
  emissionDateFrom?: string,
  emissionDateTo?: string
): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();

  if (emissionDateFrom) {
    params.append('emissionDateFrom', emissionDateFrom);
  }
  if (emissionDateTo) {
    params.append('emissionDateTo', emissionDateTo);
  }

  return axiosInstance.get(`Facturation/DownloadFacturationExcel`, {
    params,
    responseType: 'blob', 
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
}

export function getObserveFacts(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Facturation/GetObserveFacts`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function markMultipleAsViewed(
  facturationIds: number[]
): Promise<AxiosResponse<any, any>> {

  return axiosInstance.put(
    `Facturation/MarkMultipleAsViewed`,
    { facturationIds },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }
  );
}

export function updateObservation(
  facturationId: number, 
  observation: string
): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(
    `Facturation/UpdateObservation/${facturationId}`,
    { observation },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }
  );
}